import { useEffect, useRef } from 'react';

const states = [
  'AL', 'AR', 'FL', 'GA', 'IN', 'KS', 'KY', 'LA',
  'MI', 'MO', 'NE', 'NC', 'OH', 'OK', 'PA', 'SC',
  'TN', 'TX', 'WV', 'VA',
];

export default function CoverageSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = sectionRef.current?.querySelectorAll('.fade-in-child');
            children?.forEach((child, i) => {
              const el = child as HTMLElement;
              setTimeout(() => {
                el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
                el.style.opacity = '1';
                el.style.transform = 'translateY(0)';
              }, i * 40);
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 lg:py-28 bg-[#001F4E]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left */}
          <div>
            <p
              className="fade-in-child text-[#00A3E0] text-sm font-semibold uppercase tracking-widest mb-4"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Service Coverage
            </p>
            <h2
              className="fade-in-child text-3xl lg:text-4xl font-bold text-white mb-5"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Nationwide Reach,
              <br />
              <span className="text-[#00A3E0]">Local Expertise</span>
            </h2>
            <p
              className="fade-in-child text-white/70 text-base leading-relaxed mb-4"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Currently serving <strong className="text-white">20+ states</strong> across the Southeast, Midwest, and beyond, with the flexibility to go wherever the work takes us.
            </p>
            <p
              className="fade-in-child text-white/60 text-sm leading-relaxed"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Our footprint is growing, and so is our reach.
            </p>

            <div className="fade-in-child mt-8 flex gap-6" style={{ opacity: 0, transform: 'translateY(20px)' }}>
              <div className="text-center">
                <p className="text-3xl font-bold text-white">20+</p>
                <p className="text-white/60 text-xs mt-1">States Served</p>
              </div>
              <div className="w-px bg-white/20" />
              <div className="text-center">
                <p className="text-3xl font-bold text-white">Growing</p>
                <p className="text-white/60 text-xs mt-1">Nationwide Footprint</p>
              </div>
            </div>
          </div>

          {/* Right - State Grid */}
          <div>
            <p
              className="fade-in-child text-white/50 text-xs uppercase tracking-wider mb-4"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Active Coverage States
            </p>
            <div className="flex flex-wrap gap-2">
              {states.map((state) => (
                <span
                  key={state}
                  className="fade-in-child px-3 py-2 rounded-md bg-white/10 text-white text-sm font-semibold hover:bg-[#0050B2] transition-colors cursor-default"
                  style={{ opacity: 0, transform: 'translateY(20px)' }}
                >
                  {state}
                </span>
              ))}
              <span
                className="fade-in-child px-3 py-2 rounded-md bg-[#0050B2]/30 border border-[#00A3E0]/40 text-[#00A3E0] text-sm font-medium"
                style={{ opacity: 0, transform: 'translateY(20px)' }}
              >
                + More
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
